import { gql } from "@apollo/client";

import { ADMIN_FIELDS, MEMBERSHIP_FIELDS } from "src/graphql/fragments";

export const GET_ADMINS = gql`
  ${MEMBERSHIP_FIELDS}
  query listSubaccountMemberships($subaccountId: ID!) {
    listSubaccountMemberships(
      includeDeleted: true
      includeInvited: true
      subaccountId: $subaccountId
    ) {
      ...MembershipFields
    }
  }
`;

export const DELETE_ADMIN = gql`
  ${ADMIN_FIELDS}
  mutation adminDelete($id: ID!, $subaccountId: ID!) {
    adminDelete(id: $id, subaccountId: $subaccountId) {
      ...AdminFields
    }
  }
`;

export const UNDELETE_ADMIN = gql`
  ${ADMIN_FIELDS}
  mutation adminUndelete($id: ID!, $subaccountId: ID!, $role: Role!) {
    adminUndelete(id: $id, subaccountId: $subaccountId, role: $role) {
      ...AdminFields
    }
  }
`;

export const INVITE_ADMIN = gql`
  ${ADMIN_FIELDS}
  mutation adminInvite(
    $email: String!
    $fullName: String!
    $subaccountId: ID!
    $role: Role!
  ) {
    adminInvite(
      email: $email
      fullName: $fullName
      subaccountId: $subaccountId
      role: $role
    ) {
      ...AdminFields
    }
  }
`;

export const CHANGE_ADMIN_ROLE = gql`
  ${MEMBERSHIP_FIELDS}
  mutation adminChangeRole($adminId: ID!, $subaccountId: ID!, $role: Role!) {
    adminChangeRole(
      adminId: $adminId
      subaccountId: $subaccountId
      role: $role
    ) {
      ...MembershipFields
    }
  }
`;
